document.addEventListener('submit',async e=>{const f=e.target;if(f.id!=='product-form')return;e.preventDefault();const fd=new FormData(f);const r=await fetch('/cart/add.js',{method:'POST',body:fd,headers:{Accept:'application/json'}});if(r.ok){const c=document.getElementById('cart-count');if(c)c.textContent='+';window.location.href='/cart';}else{f.submit();}});
(function(){
  function initWarmPalaceProduct(){
    var thumbs=document.querySelectorAll('[data-gallery-thumb]');
    var images=document.querySelectorAll('[data-gallery-image]');
    thumbs.forEach(function(btn){
      btn.addEventListener('click',function(){
        var idx=btn.getAttribute('data-gallery-thumb');
        images.forEach(function(img){img.classList.toggle('is-hidden',img.getAttribute('data-gallery-image')!==idx);});
        thumbs.forEach(function(t){t.classList.toggle('is-active',t===btn);});
      });
    });
    var qty=document.getElementById('quantity');
    var minus=document.querySelector('[data-qty-minus]');
    var plus=document.querySelector('[data-qty-plus]');
    if(qty&&minus&&plus){
      minus.addEventListener('click',function(){qty.value=Math.max(1,(parseInt(qty.value,10)||1)-1);});
      plus.addEventListener('click',function(){qty.value=(parseInt(qty.value,10)||1)+1;});
      qty.addEventListener('input',function(){var n=parseInt(qty.value,10);if(!Number.isFinite(n)||n<1)qty.value=1;});
    }
    var toggle=document.querySelector('.wp-details-toggle');
    var content=document.querySelector('.wp-details-content');
    if(toggle&&content){
      toggle.addEventListener('click',function(){
        var open=toggle.getAttribute('aria-expanded')==='true';
        toggle.setAttribute('aria-expanded',String(!open));
        content.hidden=open;
        toggle.querySelector('b').textContent=open?'⌄':'⌃';
      });
    }
    document.querySelectorAll('.wp-mobile-buybar a').forEach(function(a){
      a.addEventListener('click',function(e){
        var target=document.getElementById('product-form');
        if(target){e.preventDefault();target.scrollIntoView({behavior:'smooth',block:'center'});}
      });
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initWarmPalaceProduct,{once:true});}
  else{initWarmPalaceProduct();}
})();
